import React, { Component } from 'react'
import './index.less'
import { inject, observer } from 'src/core/store'
import { setDocumentTitle, setUidToken, InitPage } from 'src/helper/tool'
import langM from './lang'
import { getlang, setlang } from 'src/helper/getlang'
import Message from 'src/component/Message'
import 'swiper/swiper-bundle.min.css'
import localstorage from 'src/helper/localstorage'
import config from 'src/core/config'
import { history } from 'src/core/router'

@inject('store')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.angcyStore = this.props.store.register('admin-control/agency_create')
  }

  state = {
    uid: 0,
    lang: langM.ar,
    language: 'en',
    address: '', // 联系地址
    admin_duid: "", // 会长ID
    admin_uid: 0,
    contact: "", // 联系电话
    country_code: "", // 国家地区id
    cover: "", // 封面图
    gid: "", // 工会ID
    invite_uid: 0, // 邀请人ID
    name: "", // 工会名称
    real_name: "", // 真实姓名
    remark: "", // 备注
    countryList:[]
  }

  async componentWillMount() {
    let { language } = this.props.location.query
    language = await getlang(language)
    // lang 文字对象
    // language 语言种类 (zh/ar/en)
    this.setState({
      lang: setlang(language, langM),
      language: language
    })
    let uid = await setUidToken(this.props.location.query)
    this.setState({
      uid: uid,
      invite_uid: uid // 邀请人ID
    })
    setDocumentTitle("Create Agency")
    // console.log(uid, 'uid')

    await this.RunOnStart(uid)
  }

  // 初始化/接口请求初始化
  RunOnStart = async () => {
    let { uid, accesstoken } = await localstorage.get('userInfo')
    this.angcyStore.AdminLogin(config.hostAdm, uid, accesstoken, null, (error) => {
      if (error) {
        this.refs.msg.show(error.message)
      }
    })

    let countryList = await this.angcyStore.GetCountryList(uid, (d) => {
      this.setState({
        countryList: d || []
      })
    })
    // console.log(111, countryList)
  }

  setAgencyId = (e) => {
    console.log(e.target.value)
    this.setState({ gid: e.target.value || '' })
  }

  setAdminDuid = (e) => {
    console.log(e.target.value)
    this.setState({ admin_duid: e.target.value || '' })
  }

  setName = (e) => {
    console.log(e.target.value)
    this.setState({ name: e.target.value || '' })
  }

  setCover = (e) => {
    console.log(e.target.value)
    this.setState({ cover: e.target.value || '' })
  }

  setMobilephone = (e) => {
    console.log(e.target.value)
    this.setState({ mobilephone: e.target.value || '' })
  }

  setContact = (e) => {
    console.log(e.target.value)
    this.setState({ contact: e.target.value || '' })
  }

  setAddress = (e) => {
    console.log(e.target.value)
    this.setState({ address: e.target.value || '' })
  }

  setRealName = (e) => {
    console.log(e.target.value)
    this.setState({ real_name: e.target.value || '' })
  }

  setCountryCode = (e) => {
    console.log(e.target.value)
    this.setState({ country_code: e.target.value || '' })
  }

  setRemark = (e) => {
    console.log(e.target.value, 1111)
    this.setState({ remark: e.target.value || '' })
  }

  GetCountry = (list) => {
    // console.log("list", list)
    return (
      <select onChange={e => this.setCountryCode(e)} ref={(node) => (this.nodeCountry = node)}>
        {
          list && list.map((item, index) => {
            return (
              <option key={item.countryId} value={item.countryCode}>
                {item.countryName}
              </option>
            )
          })
        }
      </select>
    )
  }


  Submit = async () => {

    console.log("state", this.state)

    let map = this.state

    if (this.state.gid == "") {
      this.refs.msg.show("Please enter the Agency ID")
      this.nodeAgencyId.focus()
      return
    }

    if (this.state.name == "") {
      this.refs.msg.show("Please enter the name")
      this.nodeAgencyName.focus()
      return
    }

    // if (this.state.cover == "") {
    //   this.refs.msg.show("Please enter the cover")
    //   this.nodeCover.focus()
    //   return
    // }

    if (this.state.admin_duid == "") {
      this.refs.msg.show("Please enter the admin duid")
      this.nodeAgencyAdminId.focus()
      return
    }

    if (this.state.mobilephone == "") {
      this.refs.msg.show("Please enter the mobilephone")
      this.nodeMobilephone.focus()
      return
    }

    if (this.state.contact == "") {
      this.refs.msg.show("Please enter the contact")
      this.nodeContact.focus()
      return
    }

    if (this.state.address == "") {
      map.address = "1"
    }

    if (this.state.real_name == "") {
      map.real_name = "1"
    }

    if (this.state.remark == "") {
      map.remark = "1"
    }

    if (this.state.country_code == "") {
      this.refs.msg.show("Please select country")
      this.nodeCountry.focus()
      return
    }


    console.log("map", map)

    let msg = await this.angcyStore.CreateGuild(config.hostAdm, map, (msg) => {
      console.log(msg)
      if (msg != "success") {
        if (msg == "未找到该用户信息") {
          this.refs.msg.show("admin user ID didn't exist")
        } else if (msg == "该用户已经是其他的公会长或公会成员") {
          this.refs.msg.show("The user is already a owner of another agency")
        } else {
          this.refs.msg.show(msg || "")
        }
      } else {
        this.refs.msg.show(this.state.lang.success)
      }
      // 开始放送
    })

  }



  render() {
    let { lang, countryList } = this.state
    return (
      <div className='admin-control-panel'>
        <div className='nav'>
          <li className='current' onClick={e => history.push(`/admin-control/agency_create`)}>Create Agency</li>
          <li onClick={e => history.push(`/admin-control/guild`)}>Send VIP</li>
        </div>
        <div className='title'>{lang.sendVip}</div>
        {/* 工会ID */}
        <div className='body-root-admin-control-panel'>
          <div className='title-name'>Agency ID</div>
          <div className="find-hanlde-view">
            <input className="input-root" onChange={e => this.setAgencyId(e)} ref={(node) => (this.nodeAgencyId = node)}></input>
          </div>
        </div>

        {/* 工会名称 */}
        <div className='body-root-admin-control-panel'>
          <div className='title-name'>Agency Name</div>
          <div className="find-hanlde-view">
            <input className="input-root" onChange={e => this.setName(e)} ref={(node) => (this.nodeAgencyName = node)}></input>
          </div>
        </div>

        {/* 封面图 */}
        {/* <div className='body-root-admin-control-panel'>
          <div className='title-name'>Cover</div>
          <div className="find-hanlde-view">
            <input className="input-root" onChange={e => this.setCover(e)} ref={(node) => (this.nodeCover = node)}></input>
          </div>
        </div> */}

        {/* 会长ID */}
        <div className='body-root-admin-control-panel'>
          <div className='title-name'>Agent ID</div>
          <div className="find-hanlde-view">
            <input className="input-root" onChange={e => this.setAdminDuid(e)} ref={(node) => (this.nodeAgencyAdminId = node)}></input>
          </div>
        </div>

        {/* 联系电话 */}
        <div className='body-root-admin-control-panel'>
          <div className='title-name'>Admin Mobilephone</div>
          <div className="find-hanlde-view">
            <input className="input-root" onChange={e => this.setContact(e)} ref={(node) => (this.nodeContact = node)}></input>
          </div>
        </div>

        {/* 联系地址 */}
        <div className='body-root-admin-control-panel'>
          <div className='title-name'>Admin Address</div>
          <div className="find-hanlde-view">
            <input className="input-root" onChange={e => this.setAddress(e)} ref={(node) => (this.nodeAddress = node)}></input>
          </div>
        </div>

        {/* 真实姓名 */}
        <div className='body-root-admin-control-panel'>
          <div className='title-name'>Real Name</div>
          <div className="find-hanlde-view">
            <input className="input-root" onChange={e => this.setRealName(e)} ref={(node) => (this.nodeAdminName = node)}></input>
          </div>
        </div>

        {/* 地区 */}
        <div className='body-root-admin-control-panel'>
          <div className='title-name'>Country</div>
          <div className="find-hanlde-view countryList">
            {this.GetCountry(countryList)}
          </div>
        </div>

        {/* 备注 */}
        <div className='body-root-admin-control-panel'>
          <div className='title-name'>Remark</div>
          <div className="find-hanlde-view">
            <input className="input-root" onChange={e => this.setRemark(e)} ref={(node) => (this.nodeRemark = node)}></input>
          </div>
        </div>

        <Message ref="msg" />
        {
          this.angcyStore.data.adminInfo.token &&
          this.angcyStore.data.adminInfo.token.length > 0 && (
            <div className='web-link' onClick={e => this.Submit()}>{lang.send}</div>
          )
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/admin-control/agency_create/index.js